import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

enum Priorities {
  LOWEST = 0,
  LOW = 10,
  MIDDLE = 20,
  HIGH = 30,
  HIGHEST = 40,
}

export const usePriority = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const priorities = {
    [Priorities.LOWEST]: {
      label: t("Priority.priorityLowest"),
      color: theme.palette.custom.levelsColor.lowest,
    },
    [Priorities.LOW]: {
      label: t("Priority.priorityLow"),
      color: theme.palette.custom.levelsColor.low,
    },
    [Priorities.MIDDLE]: {
      label: t("Priority.priorityMiddle"),
      color: theme.palette.custom.levelsColor.middle,
    },
    [Priorities.HIGH]: {
      label: t("Priority.priorityHigh"),
      color: theme.palette.custom.levelsColor.high,
    },
    [Priorities.HIGHEST]: {
      label: t("Priority.priorityHighest"),
      color: theme.palette.custom.levelsColor.highest,
    },
  } as Record<Priorities, { label: string; color: string }>;
  const getProp = useEntityProps(priorities);

  const getPriorityLabel = getProp<string>("label");
  const getPriorityColor = getProp<string>("color");
  const getPriorityOptions = () =>
    Object.entries(priorities).map(([val, props]) => ({ value: parseInt(val), ...props }));

  const isNamedPriority = (val: any): val is number =>
    Object.keys(priorities)
      .map((n) => parseInt(n))
      .includes(val);

  return { getPriorityLabel, getPriorityColor, getPriorityOptions, isNamedPriority };
};
